export default __webpack_public_path__ + "static/media/tcp.595bf2bb.jpg";